import moment from "moment";
import { ScoringCardsClient } from "@topline/services/apiService";
import { AgGridService } from "@topline/services/agGridService";
import { DateService } from "@topline/services/dateService";
import { IdSvrAuthService } from "../../auth/idSrvAuthService";
import { MarketEditService } from "./services/marketEditService";
import { ProjectDataService } from "./services/projectDataService";
import { angularServicesNames } from "@topline/services/angularServicesNames";

(function (module) {
    "use strict";
    module.controller("marketScoringCardsPolandEditCtrl", [
        "market",
        "editable",
        "projects",
        MarketEditService.componentName,
        ScoringCardsClient.componentName,
        ProjectDataService.componentName,
        AgGridService.componentName,
        "$state",
        "$scope",
        angularServicesNames.$translate,
        "AlertService",
        "modalService",
        "marketDefinitionService",
        IdSvrAuthService.componentName,
        DateService.componentName,
        marketScoringCardsPolandEditCtrl
    ]);

    function marketScoringCardsPolandEditCtrl(
        this: $TSFixMe,
        market: $TSFixMe,
        editable: $TSFixMe,
        projects: $TSFixMe,
        marketEditService: MarketEditService,
        apiClient: ScoringCardsClient,
        projectDataService: ProjectDataService,
        agGridService: AgGridService,
        $state: ng.ui.IStateService,
        $scope: $TSFixMe,
        $translate: ng.translate.ITranslateService,
        AlertService: AlertService,
        modalService: $TSFixMe,
        marketDefinitionService: $TSFixMe,
        authService: IdSvrAuthService,
        dateService: DateService
    ) {
        var $ctrl = this;
        $ctrl.market = market;
        $ctrl.projects = projects;
        $ctrl.canEdit = editable.isEditable == 1;
        $ctrl.canClone = editable.isCloneable == 1;
        authService.hasPermissionAsync("SetMarketAsFinished").then(result => $ctrl.canFinishMarket = result);
        $ctrl.readOnly = !$ctrl.canEdit;
        $ctrl.saveInProgress = false;
        $ctrl.saveAndFinishInProgress = false;
        $ctrl.priceChangeStartDate = new Date(dateService.getDefaultBudgetYear(), 0, 1);

        if ($ctrl.market && $ctrl.market.budgetYear == null) {
            $ctrl.market.budgetYear = dateService.getDefaultBudgetYear();
        }

        if (!angular.isUndefinedOrNull(angular._get(market, "project.uId"))) {
            $ctrl.marketServerOperation = projectDataService.getProjectData($ctrl.market.project.uId).then(data => {
                $ctrl.skuGridOptions.api.setRowData(data.skus);
                $ctrl.filtersGridOptions.api.setRowData($ctrl.market.filters);
            });
        }

        if (!$ctrl.canEdit && $ctrl.market.isCreatedByMy && $ctrl.canClone) {
            AlertService.warning($translate.instant("MARKET.READONLY_MODE"));
        }

        $ctrl.projectChanged = (oldValue: $TSFixMe) => {

            if (!angular.isUndefinedOrNull(oldValue) && !confirm($translate.instant("MARKET.PROJECT_CONFIG_CHANGE"))) {
                $ctrl.market.project = oldValue;
                return;
            }

            $ctrl.marketServerOperation = Promise.all([
                projectDataService.getProjectData($ctrl.market.project.uId),
                apiClient.getProjectFilters($ctrl.market.project.uId)
            ]).then(([data, filters]) => {
                var startYear = dateService.getDefaultBudgetYear();
                var endYear = parseInt(moment(data.forecastEndDate).format("YYYY"));

                $ctrl.priceChangeStartDate = new Date(startYear, 0, 1);

                $ctrl.projectYearlyData = data.projectForecast;
                $ctrl.market.forecastStartDate = data.forecastStartDate;
                $ctrl.market.forecastEndDate = data.forecastEndDate;
                
                $ctrl.market.yearlyAveragePrice = data.projectForecast
                    .filter((x: $TSFixMe) => x.averagePrice && x.year < startYear);
                
                $ctrl.market.priceChangeInYears = _.times(endYear - startYear + 1, _.constant(0));
                $ctrl.market.marketForecast = null;
                $ctrl.gridApi.setRowData(data.skus);
                $ctrl.market.filters = filters;
                $ctrl.filtersGridOptions.api.setRowData($ctrl.market.filters);
            });
        };

        const saveMarket = () => {
            $ctrl.saveInProgress = true;
            $ctrl.market.name = `${$ctrl.market.marketDefinition.name} - ${$ctrl.market.project.name}`;
            $ctrl.marketServerOperation = marketEditService.saveScoringCardsPolandMarket($ctrl.market).then(() => {
                $state.go("market.list");
                $ctrl.saveInProgress = false;
            });
        };

        const saveAndFinishMarket = () => {
            $ctrl.saveAndFinishInProgress = true;
            $ctrl.market.name = `${$ctrl.market.project.name} - ${$ctrl.market.marketDefinition.name}`;
            $scope.serverOperation = marketEditService.saveAndFinish($ctrl.market, "scoringCardsPoland").then(function (
                response: $TSFixMe
            ) {
                if (response.status != HttpStatus.OK && response.status != 204) {
                    marketEditService.displaySaveMarketError(
                        response,
                        Object.assign({}, $ctrl.market, { ["type"]: "ScoringCardsPoland" })
                    );
                    $ctrl.saveAndFinishInProgress = false;
                }
                $state.go("market.list");
            });
            $scope.marketForm.$submitted = true;
        };

        $scope.removeMarket = function () {
            if (!$ctrl.canEdit) {
                AlertService.warning($translate.instant("MARKET.READONLY_MODE"));
                return;
            }

            modalService.showConfirmationModal(
                {
                    text: "MARKET.REMOVE_CONFIRM",
                    title: "MARKET.REMOVE_CONFIRM_TITLE"
                },
                () => {
                    marketEditService.delete($ctrl.market.id)
                        .then(function () {
                            $state.go("market.list");
                            AlertService.success($translate.instant("MARKET.REMOVE_SUCCESS"));
                        })
                        .catch(function () {
                            AlertService.error($translate.instant("MARKET.REMOVE_ERROR"));
                        });
                },
                null,
                "danger"
            );
        };

        $scope.$on("LanguageChanged", () => agGridService.refreshGridLanguage($ctrl.gridApi));

        $ctrl.skuGridOptions = {
            columnDefs: [
                {
                    headerValueGetter: () => $translate.instant("MARKET.SC_GRID.PROJECT_CODE"),
                    field: "projectCode",
                    filter: "agTextColumnFilter",
                    filterParams: { newRowsAction: "keep" }
                },
                {
                    headerValueGetter: () => $translate.instant("MARKET.SC_GRID.NAME"),
                    field: "name",
                    filter: "agTextColumnFilter",
                    filterParams: { newRowsAction: "keep" }
                }
            ],
            angularCompileRows: true,
            animateRows: true,
            defaultColDef: {
                sortable: true,
                resizable: true
            },
            floatingFilter: true,
            suppressMultiSort: true,
            domLayout: "autoHeight",
            pagination: true,
            paginationPageSize: 10,
            localeTextFunc: agGridService.transalteFunc,
            suppressHorizontalScroll: true,
            onGridReady: (config: $TSFixMe) => {
                $ctrl.gridApi = config.api;
                config.api.sizeColumnsToFit();
            },
            onGridSizeChanged: (config: $TSFixMe) => {
                config.api.sizeColumnsToFit();
            }
        };

        $ctrl.filtersGridOptions = {
            columnDefs: [
                {
                    field: "molecule",
                    headerValueGetter: () => $translate.instant("MARKET.SC_FILTERS_GRID.MOLECULE"),
                    tooltipField: "molecule"
                },
                {
                    field: "moleculeAll",
                    headerValueGetter: () => $translate.instant("MARKET.SC_FILTERS_GRID.MOLECULE_All"),
                    tooltipField: "moleculeAll"
                },
                {
                    field: "manufacturer",
                    headerValueGetter: () => $translate.instant("MARKET.SC_FILTERS_GRID.MANUFACTURER"),
                    tooltipField: "manufacturer"
                },
                {
                    field: "company",
                    headerValueGetter: () => $translate.instant("MARKET.SC_FILTERS_GRID.COMPANY"),
                    tooltipField: "company"
                },
                {
                    field: "rxOtc",
                    headerValueGetter: () => $translate.instant("MARKET.SC_FILTERS_GRID.RXOTC"),
                    tooltipField: "rxOtc"
                },
                {
                    field: "monoCombo",
                    headerValueGetter: () => $translate.instant("MARKET.SC_FILTERS_GRID.MONO_COMBO"),
                    tooltipField: "monoCombo"
                },
                {
                    field: "pharmacyMarket",
                    headerValueGetter: () => $translate.instant("MARKET.SC_FILTERS_GRID.PHARMACY_MARKET"),
                    tooltipField: "pharmacyMarket"
                },
                {
                    field: "doses",
                    headerValueGetter: () => $translate.instant("MARKET.SC_FILTERS_GRID.DOSES"),
                    tooltipField: "doses"
                },
                {
                    field: "atcOtc1",
                    headerValueGetter: () => $translate.instant("MARKET.SC_FILTERS_GRID.ATC_OTC_1"),
                    tooltipField: "atcOtc1"
                },
                {
                    field: "atcOtc2",
                    headerValueGetter: () => $translate.instant("MARKET.SC_FILTERS_GRID.ATC_OTC_2"),
                    tooltipField: "atcOtc2"
                },
                {
                    field: "atcOtc3",
                    headerValueGetter: () => $translate.instant("MARKET.SC_FILTERS_GRID.ATC_OTC_3"),
                    tooltipField: "atcOtc3"
                },
                {
                    field: "atcOtc4",
                    headerValueGetter: () => $translate.instant("MARKET.SC_FILTERS_GRID.ATC_OTC_4"),
                    tooltipField: "atcOtc4"
                },
                {
                    field: "nfc1",
                    headerValueGetter: () => $translate.instant("MARKET.SC_FILTERS_GRID.NFC_1"),
                    tooltipField: "nfc1"
                },
                {
                    field: "nfc2",
                    headerValueGetter: () => $translate.instant("MARKET.SC_FILTERS_GRID.NFC_2"),
                    tooltipField: "nfc2"
                },
                {
                    field: "nfc3",
                    headerValueGetter: () => $translate.instant("MARKET.SC_FILTERS_GRID.NFC_3"),
                    tooltipField: "nfc3"
                },
                {
                    field: "brands",
                    headerValueGetter: () => $translate.instant("MARKET.SC_FILTERS_GRID.BRANDS"),
                    tooltipField: "brands"
                }
            ],
            angularCompileRows: true,
            animateRows: true,
            defaultColDef: {
                sortable: false,
                resizable: true
            },
            domLayout: "autoHeight",
            localeTextFunc: agGridService.transalteFunc,
            suppressHorizontalScroll: false,
            onGridReady: (config: $TSFixMe) => {
                $ctrl.gridApi = config.api;
                config.api.sizeColumnsToFit();
            },
            onGridSizeChanged: (config: $TSFixMe) => {
                config.api.sizeColumnsToFit();
            }
        };

        $ctrl.getRequirementsErrorMessage = () => {
            const checkResult = $ctrl.meetsRequirementsCheckResult;

            if (!checkResult) return "";

            return !checkResult.satisfiesMarketType ? $translate.instant("MARKET.MARKET_TYPE_REQUIREMENT_ERROR") : "";
        };

        $ctrl.onKamsoftMarketTypeChange = () => {
            $ctrl.market.similarNeeds = undefined;
        };

        const getRequirementsModalErrorMessage = () => {
            const message = $ctrl.getRequirementsErrorMessage();
            const ending = $translate.instant("MARKET.REQUIREMENT_ERROR");

            return `${message} ${ending}`;
        };

        const showRequirementsWarningModal = (onAccept: $TSFixMe) => modalService.showConfirmationModalStr(
            {
                text: getRequirementsModalErrorMessage(),
                title: $translate.instant("MARKET.HAS_REQUIREMENT_ERRORS_TITLE"),
                okText: $translate.instant("SAVE")
            },
            onAccept,
            null,
            "warning"
        );

        const showRequirementsErrorModal = () =>
            modalService.showErrorModalStr({
                text: getRequirementsModalErrorMessage(),
                title: $translate.instant("MARKET.HAS_REQUIREMENT_ERRORS_TITLE")
            });

        $scope.actions = {
            save: () => {
                if ($scope.marketForm.$valid) {
                    $ctrl.saveInProgress = true;
                    marketEditService.checkScoringCardsPolandMarketRequirements(
                        $ctrl.market.filters,
                        $ctrl.market.kamsoftMarketType
                    ).then((checkResult: $TSFixMe) => {
                        $ctrl.meetsRequirementsCheckResult = checkResult;
                        if (checkResult.hasErrors) {
                            $ctrl.saveInProgress = false;
                            checkResult.satisfiesMarketType
                                ? showRequirementsWarningModal(saveMarket)
                                : showRequirementsErrorModal();
                        } else {
                            saveMarket();
                        }
                    });
                } else {

                    const $elm = angular
                        .element("[name='" + $scope.marketForm.$name + "']")
                        .find(".ng-invalid:visible:first")
                        .first();
                    // @ts-expect-error ts-migrate(2581) FIXME: Cannot find name '$'. Do you need to install type ... Remove this comment to see the full error message
                    $("html,body").animate({ scrollTop: $elm.offset().top }, "slow");
                }

                $scope.marketForm.$submitted = true;
            },
            saveAndFinish: () => {
                if ($scope.marketForm.$valid) {
                    $ctrl.saveAndFinishInProgress = true;
                    marketEditService.checkScoringCardsPolandMarketRequirements(
                        $ctrl.market.filters,
                        $ctrl.market.kamsoftMarketType
                    ).then((checkResult: $TSFixMe) => {
                        $ctrl.meetsRequirementsCheckResult = checkResult;
                        if (checkResult.hasErrors) {
                            $ctrl.saveAndFinishInProgress = false;
                            checkResult.satisfiesMarketType
                                ? showRequirementsWarningModal(saveAndFinishMarket)
                                : showRequirementsErrorModal();
                        } else {
                            saveAndFinishMarket();
                        }
                    });
                } else {

                    const $elm = angular
                        .element("[name='" + $scope.marketForm.$name + "']")
                        .find(".ng-invalid:visible:first")
                        .first();
                    // @ts-expect-error ts-migrate(2581) FIXME: Cannot find name '$'. Do you need to install type ... Remove this comment to see the full error message
                    $("html,body").animate({ scrollTop: $elm.offset().top }, "slow");
                }
                $scope.marketForm.$submitted = true;
            }
        };

        marketDefinitionService.getActive().then((marketDefinitions: $TSFixMe) => $ctrl.marketDefinitions = marketDefinitions);
        marketEditService.getSimilarNeeds().then(
            (similarNeeds: $TSFixMe) => $ctrl.similarNeeds = similarNeeds.map((sn: $TSFixMe) => sn.name)
        );
    }

})(angular.module("topline.chamferForecast"));
